// extracted by mini-css-extract-plugin
export default {"MenuContainer":"styles_MenuContainer__4R7Mh","scroller":"styles_scroller__PtxzG"};